import React from 'react'
import { BoundedContent, Box, GridContainer, Row, Column, Link } from '@vp/swan'
import { TokenReplacer, LinkFactory } from '@vp/digital-token-replacer-lib-ubik'

import { trackFAQLinks } from '../WixDomainsPDPAnalytics'
import { getFree1YearDomainVoucherUrl } from '@vp/digital-url-service-lib-ubik'
import { FaqContainer } from '@vp/digital-faq-lib-ubik'
import { useLocale } from '@vp/digital-locale-lib-ubik'
import { appendSourceParam, getVistaWixLegacyCustomerHelpUrl } from '../../../common/helpers/wixDomainsUrls'
import { sourceEnum } from '../../../common/enum/sourceEnum'
import { LocalizedUrl } from '../../../../types/LocalizedUrl'
import { CommonFeatures } from '../../../../types/CommonFeatures'

interface FaqSectionProps {
  faqs: CommonFeatures
  locale: string
  wixWebsitesAnonymousPlansUrlLocalized: LocalizedUrl
}
const FaqSection = ({ locale, wixWebsitesAnonymousPlansUrlLocalized, faqs }: FaqSectionProps) => {
  const { languageCode } = useLocale()
  const websitePlansUrl = appendSourceParam(wixWebsitesAnonymousPlansUrlLocalized.url, sourceEnum.DOMAINS_PDP_FAQ)
  const faqsData: any = {
    title: faqs.title,
    features: faqs?.features
      ?.filter((feature: any) => !feature?.key || (feature?.key === 'vistaWixLegacyFaqs' && locale === 'en-US'))
      .map((feature: any) => ({
        title: feature.name,
        description: (
          <TokenReplacer
            template={feature.description}
            replacements={{
              link: LinkFactory(
                {
                  domainsSearchBar: '#digital-search-component-section',
                },
                null,
                '_self',
              ),

              premiumWebsitePlan: (
                <>
                  <Link
                    href={websitePlansUrl}
                    onClick={() => {
                      trackFAQLinks(websitePlansUrl)
                    }}
                  >
                    {faqs.features?.[0].valueText ?? ''}
                  </Link>
                </>
              ),

              vistaXWixPremiumPlan: (
                <>
                  <Link
                    href={websitePlansUrl}
                    onClick={() => {
                      trackFAQLinks(websitePlansUrl)
                    }}
                  >
                    {faqs.features?.[1].valueText ?? ''}
                  </Link>
                </>
              ),

              yearlyPremiumWebsitePlan: (
                <>
                  <Link
                    href={websitePlansUrl}
                    onClick={() => {
                      trackFAQLinks(websitePlansUrl)
                    }}
                  >
                    {faqs.features?.[4].valueText ?? ''}
                  </Link>
                </>
              ),

              firstYearSubscription: (
                <>
                  <Link
                    href={getFree1YearDomainVoucherUrl(languageCode)}
                    onClick={() => {
                      trackFAQLinks(getFree1YearDomainVoucherUrl(languageCode))
                    }}
                  >
                    {faqs.features?.[1].hoverText ?? ''}
                  </Link>
                </>
              ),

              learnMore: (
                <>
                  <Link
                    href={getFree1YearDomainVoucherUrl(languageCode)}
                    onClick={() => {
                      trackFAQLinks(getFree1YearDomainVoucherUrl(languageCode))
                    }}
                  >
                    {faqs.features?.[4].hoverText ?? ''}
                  </Link>
                </>
              ),

              vistaWixLegacyFaqsUrl: (
                <>
                  <Link
                    href={getVistaWixLegacyCustomerHelpUrl()}
                    onClick={() => {
                      trackFAQLinks(getVistaWixLegacyCustomerHelpUrl())
                    }}
                  >
                    {faqs.features?.[5].valueText ?? ''}
                  </Link>
                </>
              ),
            }}
            convertMarkdown
          />
        ),
      })),
  }

  return (
    <>
      {faqsData && (
        <Box as="article" className="wix-domains-pdp__faq__container" pt={10} pb={10}>
          <BoundedContent>
            <GridContainer>
              <Row>
                <Column span={12}>
                  <FaqContainer content={faqsData} titleSize="x3large" />
                </Column>
              </Row>
            </GridContainer>
          </BoundedContent>
        </Box>
      )}
    </>
  )
}

export default FaqSection
